import React, { useState, useEffect, useContext} from "react";
import "./reviewModal.scss";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import { Link } from "react-router-dom";
import { withTranslation, useTranslation } from "react-i18next";
import Backdrop from "@mui/material/Backdrop";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
// External Components
import Rating from '@mui/material/Rating';
import { TextareaAutosize } from "@material-ui/core";
// import {handleCustomerReview} from "../../../../redux-store/action"
import LoaderAnimation from "../LoaderAnimation";
// Context api calling
import StateContext from "../../StateContext";
// Axios
import axios from "axios"
import { handleError } from "../../Functions/getAlert";
import DispatchContext from "../../DispatchContext";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const ReviewModal = ({ storeInfo, invoiceDetail }) => {
 
  const { t } = useTranslation();
  const appState = useContext(StateContext);
  const appDispatch = useContext(DispatchContext);
  const [fullWidth] = React.useState(true);
  const [maxWidth] = React.useState("lg");
  const [value, setValue] = useState(5);
  const [alertMessage, setAlertMessage] = useState({
    open: false,
    message: "",
  });
  const [review, setReview] = useState('')
  const [open, setOpen ] = useState(false)
  const [loading, setLoading] = useState(false)
  const starStyle = {
    width: 30,
    height: 30,
    padding: 100,
    color: "green"
  }
  const handleClose = () =>{
setOpen(false)
  }

  const handleSubmit = async () => {
    setLoading(true)
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}rating/add`,{
          invoice_id: invoiceDetail.id,
          rating: value ? value : 1,
          review: review
        }
       
      );
        //console.log(res)
      if(res.data.success === true){
        setAlertMessage({
          open: true,
          message: res.data.message,
          alertSuccess: true,
        });
        setOpen(false)
        setLoading(false)
      }
      
      else{
        setAlertMessage({
          open: true,
          message: res.data.message,
          alertSuccess: false,
        });
        setLoading(false)
        }
    } catch (e) {
      Promise.reject(e);
      if(e.response.status === 401){
      }
setLoading(false)      
      handleError(e, appDispatch)
    }
  }

  const handleReview = (e) => {
    setReview(e.target.value)
  }

  function getLabelText(value) {
    return `${value} Star${value !== 1 ? 's' : ''}, ${labels[value]}`;
  }
  const [hover] = React.useState(-1);
  const labels = {
    0: "wao",
    1: 'Terrible',
    2: 'Bad',
    3: 'Ok',
    4: 'Good',
    5: 'Great',
  };

  useEffect(() => {
   if(!invoiceDetail.isReviewed && invoiceDetail.status === "Paid"){
    setOpen(true)
   }

  }, [])
  
  useEffect(() => {
    setTimeout(
      () => setAlertMessage({ open: false, message: "", alertSuccess: false }),
      8000
    );
  }, [alertMessage.open]);

  return (
    <>
          <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={alertMessage.open}
        className={alertMessage.alertSuccess ? "success-alert" : "danger-alert"}
      >
        {alertMessage.alertSuccess ? (
          <Alert severity="success">{alertMessage.message}</Alert>
        ) : (
          <Alert severity="error">{alertMessage.message}</Alert>
        )}
      </Snackbar>
     {loading && (
          <Backdrop
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={loading}
          >
            <LoaderAnimation />
          </Backdrop>
        )}
    <Dialog
      fullWidth={fullWidth}
      maxWidth={maxWidth}
      // open={appState.reviewModal}
      open={open}


      // onClose={handleClose}
    >
      <DialogContent 
      className="my-2"
      >
        <div
          className={`${appState.langValue === "ar" ? "directionRtl" : ""}`}
          id="reviewModalMainl1"

        >
          <IconButton className="ml-auto my-1 d-flex" onClick={handleClose}>
            <CloseIcon />
          </IconButton>
          <h1 className="text-center mt-2"> {t("Review.How-was-your-experience")} {storeInfo.business_name}?</h1>
          <div className="px-1">
            <div className="container-fluid mt-3">

              <div className="row d-flex justify-content-center store-tilte-card py-2">
                <div className="col-md-2 col-6 px-0 d-flex justify-content-end  align-items-center">
                  <Link to="/">
                    <div className="imgDiv d-flex align-items-center w-100  px-1">
                      <img
                        src={
                          storeInfo.logo
                            ? `${storeInfo.logo}`
                            : `${process.env.REACT_APP_API_URL}storage/app/public/stores/logo/no_image_logo.png`
                        }
                        className="w-100 h-100 img-fluid"
                        alt=""
                      />
                    </div>
                  </Link>
                </div>
                <div className="col-6 d-flex flex-column justify-content-center px-0">
                  <div className={`mt-2 ${appState.langValue === "ar"
                    ? "text-right"
                    : "text-left"
                    }`} >
                    <h2 className={`d-flex mb-0 ${appState.langValue === "ar"
                      ? "text-right"
                      : "text-left"
                      }`} >{storeInfo.business_name}</h2>
                    {/* <p className={`d-flex bussinessDecs ${appState.langValue === "ar"
                      ? "text-right"
                      : "text-left"
                      }`}>{appState.newApi.business.description.en &&
                        appState.newApi.business.description.en}</p>
                  {appState.storeTime ? <p className={`d-flex familyManrope400 ${appState.langValue === "ar"
                  ? "text-right"
                  : "text-left"
                  }`}> <span>{
                    appState.storeTime.open_time}</span>- <span>{
                      appState.storeTime.close_time}</span> </p> : ""} */}

                  </div>
                </div>
              </div>
            </div>
            <div className="container-fluid px-0">

              <h3 className={`d-flex familyManrope800 mt-2 ${appState.langValue === "ar"
                ? "text-right"
                : "text-left"
                }`}
              >
                {t("Review.Rate-the-experience")}</h3>
                
              <div className="row mt-2">
                <div className="col-12 d-flex justify-content-center ">
                  <Rating name="size-medium" defaultValue={4} value={value} getLabelText={getLabelText}
                    onChange={(event, newValue) => { newValue == null ? setValue(5) : setValue(newValue)
                    }}
                    size="medium"
                    itemStyle={starStyle}
                    />
                   
                </div>
                <div className="col-12 d-flex align-items-center justify-content-center">
                     
                           {value !== null && (
                      <h4 className="familyManrope800" >{labels[hover !== -1 ? hover : value]}</h4>
                    )}
                            {value == null && (
                      <h4 >&nbsp;</h4>
                    )}
                    </div>
              </div>
              <div className="addInstructions  py-md-2">
                <p className={`familyManrope600 textBlack pt-md-2 pb-1 ${appState.langValue === "ar"
                  ? "text-right"
                  : "text-left"
                  }`}
                >{t("Review.Can-you-share-your-thought-about-the-experience")}</p>
                
                <TextareaAutosize
                  className="textArea"
                  aria-label="minimum height"
                  width="100%"
                  minRows={1}
                  placeholder={t("Review.Type-your-note-here")}
                  onChange={handleReview}
                // onChange={handlechange("instructions")}
                // value={
                //   !appState.loggedIn
                //     ? formData.instructions
                //     : ""
                // }
                // disabled={
                //   appState.loggedIn
                //     ? appState.userInfo !== []
                //       ? true
                //       : false
                //     : false
                // }
                />
              </div>
              <div className="row mx-0 d-flex justify-content-center pb-1 pt-2 submitBtn">
                <Button className="col-md-9 col-12 blackBtn py-3 text-capitalized" onClick={handleSubmit} >{t("Review.submit")}</Button>
              </div>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
    </>
  );
};
export default withTranslation()(ReviewModal);